export default __webpack_public_path__ + "static/Gotham-Book-ef38e10a9a0e35a1a5ec85e36bcd83fb.woff";